export default "__VITE_ASSET__B_ymS0jH__"